// extracted by mini-css-extract-plugin
module.exports = {"status-toggle":"Notifications_status-toggle__3jRX7","toggle":"Notifications_toggle__32P4m","active":"Notifications_active__12THB"};